import { screensCopy } from '@/copy/screens';
import { EmptyState, Plate } from '../kit';
import { Part } from '../Part';
import { homeCards } from '../registry';

/** Home: "What went down", composed from module Home cards in `order`. */
export default function Home() {
  const cards = homeCards();
  return (
    <div className="flex flex-col gap-6">
      <Plate color="butter">{screensCopy.home.title}</Plate>
      {cards.length === 0 && <EmptyState title={screensCopy.home.empty} />}
      {cards.map((c) => (
        <Part key={`${c.module}:${c.id}`} name={`${c.module}:${c.id}`} loader={c.component} />
      ))}
    </div>
  );
}
